import styled from 'styled-components';

const RectangleButton = styled<{ invalid?: boolean, inverted?: boolean }, 'button'>('button')`
  width: 100%;
  border: none;

  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => (props.invalid ? '#dfe0df' : (props.inverted ? '#ffffff' : '#00144d'))};
  border-radius: 4px;
  height: 48px;

  font-weight: bold;
  line-height: normal;
  font-size: 14px;
  text-align: center;

  color: ${props => (props.inverted ? '#00144D' : '#ffffff')};

  cursor: pointer;

  -webkit-transition: all 0.15s ease-in-out;
  -moz-transition: all 0.15s ease-in-out;
  -ms-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;

  :focus {
    outline: none;
  }

  :hover {
    background-color: ${props => (props.invalid ? '#dfe0df' : (props.inverted ? '#ffffff' : 'rgba(0, 20, 77, 0.8)'))};
    border: none;
  }
`;

export default RectangleButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/RectangleButton.tsx